import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const RelatedBlockItem = ({ title, slug }) =>
  <Link className="related-block__list__item" to={slug}>{title}</Link>;

export default RelatedBlockItem;

RelatedBlockItem.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./js/components/RelatedBlockItem.js